<template>
  <v-card class="border-radius pa-2">
    <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
      <v-avatar size="35">
        <v-img
          contain
          width="30"
          height="30"
          alt="vuetify"
          :src="require('@/assets/logo/favicon.png')">
          <template v-slot:placeholder>
            <v-row
              class="fill-height"
              align="center"
              justify="center">
              <v-progress-circular 
                indeterminate 
                color="#ff64ad">
              </v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-avatar>

      <span class="mt-1 ml-1">
        {{ Object.keys(detail).length > 0 ? 'Ubah Data' : 'Tambah' }} {{ config.action.add.text !== undefined ? config.action.add.text : $route.meta.title }}
      </span>

      <v-spacer/>

      <v-icon 
        @click="$emit('screen', !fullscreen ? true : false)"
        class="cursor-pointer mr-1"
        size="24"
        color="#ff64ad">
        {{ !fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
      </v-icon>

      <v-icon 
        @click="reset()"
        class="cursor-pointer"
        size="24"
        color="red">
        mdi-close-circle-outline
      </v-icon>
    </v-card-title>

    <v-divider class="mx-4 mt-3 mb-2"/>

    <v-card-text class="pt-2" :style="form.length > 10 ? 'height: 750px' : ''">
      <ValidationObserver ref="form">
        <v-form>
          <v-row v-for="(item, index) in form" :key="index">
            <!-- ID -->
            <v-text-field v-if="item.hide"
              style="display: none;"
              dense
              outlined
              color="#ff64ad"
              hide-details
              v-model="item.value"
              v-uppercase>
            </v-text-field>
            
            <v-col v-if="item.type !== 'column' && item.type !== 'id' && !item.hide">
              <div v-if="item.type === 'text' || item.type === 'number'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${item.width};`"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    :type="item.type"
                    :placeholder="item.placeholder"
                    v-model="item.value"
                    v-uppercase
                    :success="item.value !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'select'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-select
                    :style="`max-width: ${item.width};`"
                    dense
                    outlined
                    single-line
                    hide-details
                    color="#ff64ad"
                    item-color="pink darken-1"
                    :placeholder="item.placeholder"
                    :items="item.option"
                    item-value="value"
                    item-text="text"
                    v-model="item.value"

                    @change="selected(item)"

                    :success="item.value !== '' && valid"
                    :error-messages="errors">
                    <template slot="selection" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>

                    <template slot="item" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>
                    
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'radio'">
                <p class="mb-2">
                  {{ item.label }}
                </p>

                <v-radio-group
                  class="mt-0"
                  v-model="item.value"
                  row
                  hide-details>
                  <v-radio v-for="(radio, i) in item.option" :key="i"
                    :label="radio.text"
                    color="#ff64ad"
                    :value="radio.value">
                  </v-radio>
                </v-radio-group>
              </div>

              <div v-if="item.type === 'date'">
                <p class="mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <v-menu
                  :ref="`date${index}`"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="item.picker">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      :name="item.label" 
                      :rules="item.rules"
                      v-slot="{ errors, valid }">
                        <v-text-field
                          :style="`max-width: ${item.width};`"
                          v-model="item.value"
                          v-uppercase
                          readonly
                          outlined
                          dense
                          color="#ff64ad"
                          :placeholder="item.placeholder"
                          hide-details
                          clearable
                          @click:clear="item.value = ''"
                          v-on="on"
                          v-bind="attrs"
                          :success="item.value !== '' && valid"
                          :error-messages="errors">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ item.label }} {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="item.value !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    color="#ff64ad"
                    v-model="item.value"
                    @input="item.picker = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div v-if="item.type === 'textarea'">
                <ValidationProvider 
                  :name="item.label" 
                  :rules="item.rules"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text" v-if="item.required">*</span>
                    {{ item.label }}
                    <span :class="item.required ? 'error--text' : ''">
                      ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-textarea
                    :style="`max-width: ${item.width};`"
                    outlined
                    dense
                    :rows="item.rows"
                    hide-details
                    color="#ff64ad"
                    :type="item.type"
                    :placeholder="item.placeholder"
                    v-model="item.value"
                    v-uppercase
                    :success="item.value !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ item.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="item.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </div>

              <div v-if="item.type === 'texteditor'">
                <p class="mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>
                
                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: item.placeholder
                  }"
                  v-model="item.value">
                </quill-editor>
              </div>

              <div v-if="item.type === 'image'">
                <p class="mb-2">
                  <span class="red--text" v-if="item.required">*</span>
                  {{ item.label }}
                  <span :class="item.required ? 'error--text' : ''">
                    ({{ item.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <uploadfolder v-model="images">
                  <div slot="activator">
                    <v-card
                      outlined
                      class="d-flex align-center justify-center cursor-pointer"
                      :width="item.full === undefined ? 175 : '100%'"
                      :height="item.full === undefined ? 175 : 250"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <v-avatar v-if="!process.image"
                        v-ripple
                        tile 
                        :width="item.full === undefined ? 173 : '100%'"
                        :height="item.full === undefined ? 173 : 250"
                        class="cursor-pointer">
                        <v-img 
                          v-if="item.value.length > 0"
                          contain
                          :width="item.full === undefined ? 173 : '100%'"
                          :height="item.full === undefined ? 173 : 250"
                          alt="vuetify"
                          :src="item.value">
                        </v-img>

                        <v-icon v-else size="50" color="grey">mdi-cloud-upload-outline</v-icon>
                      </v-avatar>

                      <v-progress-circular v-else
                        indeterminate
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </v-col>

            <v-col v-show="item.type === 'column' && item.type !== 'id' && !item.hide"
              v-for="(subItem, key) in item.sub" :key="key">
              <div v-if="subItem.type === 'text' || subItem.type === 'number'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-text-field
                    :style="`max-width: ${subItem.width};`"
                    dense
                    outlined
                    color="#ff64ad"
                    hide-details
                    :type="subItem.type"
                    :placeholder="subItem.placeholder"
                    v-model="subItem.value"
                    v-uppercase
                    :success="subItem.value !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </div>

              <div v-if="subItem.type === 'select'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-select
                    :style="`max-width: ${subItem.width};`"
                    dense
                    outlined
                    single-line
                    hide-details
                    color="#ff64ad"
                    item-color="pink darken-1"
                    :placeholder="subItem.placeholder"
                    :items="subItem.option"
                    item-value="value"
                    item-text="text"
                    v-model="subItem.value"

                    @change="selected(subItem)"

                    :success="subItem.value !== '' && valid"
                    :error-messages="errors">
                    <template slot="selection" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>

                    <template slot="item" slot-scope="data">
                      <span class="text-capitalize">
                        {{ data.item.text }}
                      </span>
                    </template>
                    
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-select>
                </ValidationProvider>
              </div>

              <div v-if="subItem.type === 'radio'">
                <p class="mb-2">
                  {{ subItem.label }}
                </p>

                <v-radio-group
                  class="mt-0"
                  v-model="subItem.value"
                  row
                  hide-details>
                  <v-radio v-for="(radio, i) in subItem.option" :key="i"
                    :label="radio.text"
                    color="#ff64ad"
                    :value="radio.value">
                  </v-radio>
                </v-radio-group>
              </div>

              <div v-if="subItem.type === 'date'">
                <p class="mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <v-menu
                  :ref="`date${index}`"
                  min-width="290px"
                  max-width="290px"
                  transition="scale-transition"
                  offset-y
                  :nudge-right="40"
                  :close-on-content-click="false"
                  v-model="subItem.picker">
                  <template v-slot:activator="{ on, attrs }">
                    <ValidationProvider 
                      :name="subItem.label" 
                      :rules="subItem.rules"
                      v-slot="{ errors, valid }">
                        <v-text-field
                          :style="`max-width: ${subItem.width};`"
                          v-model="subItem.value"
                          v-uppercase
                          readonly
                          outlined
                          dense
                          color="#ff64ad"
                          :placeholder="subItem.placeholder"
                          hide-details
                          clearable
                          @click:clear="subItem.value = ''"
                          v-on="on"
                          v-bind="attrs"
                          :success="subItem.value !== '' && valid"
                          :error-messages="errors">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ subItem.label }} {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="subItem.value !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                    </ValidationProvider>
                  </template>

                  <v-date-picker 
                    color="#ff64ad"
                    v-model="item.value"
                    @input="item.picker = false">
                  </v-date-picker>
                </v-menu>
              </div>

              <div v-if="subItem.type === 'textarea'">
                <ValidationProvider 
                  :name="subItem.label" 
                  :rules="subItem.rules"
                  v-slot="{ errors, valid }">
                  <p class="mb-2">
                    <span class="red--text" v-if="subItem.required">*</span>
                    {{ subItem.label }}
                    <span :class="subItem.required ? 'error--text' : ''">
                      ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                    </span>
                  </p>

                  <v-textarea
                    :style="`max-width: ${subItem.width};`"
                    outlined
                    dense
                    :rows="subItem.rows"
                    hide-details
                    color="#ff64ad"
                    :type="subItem.type"
                    :placeholder="subItem.placeholder"
                    v-model="subItem.value"
                    v-uppercase
                    :success="subItem.value !== '' && valid"
                    :error-messages="errors">
                    <template v-slot:append-outer>
                      <div v-if="errors.length > 0">
                        <v-tooltip top color="#ff5252">
                          <template v-slot:activator="{ on }">
                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                          </template>
                          
                          {{ subItem.label }} {{ errors[0] }}
                        </v-tooltip>
                      </div>

                      <div v-if="subItem.value !== '' && valid">
                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                      </div>
                    </template>
                  </v-textarea>
                </ValidationProvider>
              </div>

              <div v-if="subItem.type === 'texteditor'">
                <p class="mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>
                
                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: subItem.placeholder
                  }"
                  v-model="subItem.value">
                </quill-editor>
              </div>

              <div v-if="subItem.type === 'image'">
                <p class="mb-2">
                  <span class="red--text" v-if="subItem.required">*</span>
                  {{ subItem.label }}
                  <span :class="subItem.required ? 'error--text' : ''">
                    ({{ subItem.required ? 'wajib diisi' : 'boleh dikosongi' }})
                  </span>
                </p>

                <uploadfolder v-model="images">
                  <div slot="activator">
                    <v-card
                      outlined
                      class="d-flex align-center justify-center cursor-pointer"
                      :width="subItem.full === undefined ? 175 : '100%'"
                      :height="subItem.full === undefined ? 175 : 250"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <v-avatar v-if="!process.image"
                        v-ripple
                        tile 
                        :width="subItem.full === undefined ? 173 : '100%'"
                        :height="subItem.full === undefined ? 173 : 250"
                        class="cursor-pointer">
                        <v-img 
                          v-if="subItem.value.length > 0"
                          contain
                          :width="subItem.full === undefined ? 173 : '100%'"
                          :height="subItem.full === undefined ? 173 : 250"
                          alt="vuetify"
                          :src="subItem.value">
                        </v-img>

                        <v-icon v-else size="50" color="grey">mdi-cloud-upload-outline</v-icon>
                      </v-avatar>

                      <v-progress-circular v-else
                        indeterminate
                        color="#ff64ad">
                      </v-progress-circular>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>

      <v-alert 
        type="error" 
        text dense prominent 
        class="mt-6"
        v-show="message.error.length > 0">
        {{ message.error }}
      </v-alert>
    </v-card-text>

    <v-divider class="mx-4 mb-3 mt-0"/>

    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="#ff64ad"
        elevation="0"
        class="body-2 font-weight-bold text-capitalize white--text"
        :disabled="process.form"
        :loading="process.form"
        v-on:keyup.enter="save()"
        @click="save()">
        <v-icon small class="mr-1">mdi-check-bold</v-icon>
        Simpan
      </v-btn>

      <v-btn
        outlined
        class="body-2 font-weight-bold text-capitalize red--text"
        :disabled="process.form"
        @click="reset()">
        <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
        Batal
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      detail: {
        type: Object,
        default: {}
      },
      config: {
        type: Object,
        default: {}
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        images: null,
        form: {},
        process: {
          form: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      }
    },
    watch: {
      'images': {
        handler: function () {
          if (this.images) {
            this.process.image = this.images.process 

            if (!this.process.image) this.form.map(obj => { if (obj.type === 'image') obj.value = this.images.data.full.file_url })
          }
        },
        deep: true
      }
    },
    mounted () {
      this.form = this.config.form
    },
    methods: {
      selected (item) {
        this.form.map(obj => { 
          if (obj.relation === item.field) {
            let data = item.option.filter(function(v) {
              return item.value === v.value
            })

            if (data.length > 0) {
              obj.value = data[0].text
            }
          }
        })
      },
      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.$emit('close', false)
        
        this.process.form = false

        this.message.error = ''
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let forms = {}

          this.form.map(obj => {
            if (obj.type === 'column') {
              obj.sub.map(obj_sub => {
                forms[obj_sub.field] = obj_sub.value
              })
            } else {
              forms[obj.field] = obj.value
            }
          })
          
          let url = forms.id.length < 1 ? this.config.action.add.api : this.config.action.edit.api

          // SAVE TO REST API
          await post(url, {
            data: forms
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.reset()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>